import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=5eb5af5a"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=js"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&id=5eb5af5a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports